// Estilos globais
import '@/assets/style.css';

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import 'v-calendar/style.css';

import { createApp } from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import i18n from "@/assets/locales/i18n";
import App from '@/App.vue'
import router from '@/router'
import CacheManager from '@/router/cacheManager';


import { initFacebookSdk } from '@/assets/facebookSdk.js';



// Inicializa o Facebook SDK e depois monta o app Vue
initFacebookSdk()
      .then(() => {
            console.log("Facebook SDK carregado com sucesso.");
            
      })
      .catch((error) => {
            console.error("Erro ao carregar o Facebook SDK:", error);
            
      });




// ----------------------------------------------------
// Icons
// ----------------------------------------------------
import robotIcon from "@/resources/icons/robotIcon.vue";
import iconGalery from "@/resources/icons/iconGalery.vue";
import iconAudioWave from "@/resources/icons/iconAudioWave.vue";
import iconResponse from "@/resources/icons/iconResponse.vue";
import icon3Dots from "@/resources/icons/icon3Dots.vue";
import iconConnection from './resources/icons/iconConnection.vue';
import iconContacts from './resources/icons/iconContacts.vue';
import iconEdit from './resources/icons/iconEdit.vue';
import iconDelete from './resources/icons/iconDelete.vue';
import iconWebhook from './resources/icons/iconWebhook.vue';
import iconAlert from './resources/icons/iconAlert.vue';
import iconFunnel from './resources/icons/iconFunnel.vue';
import iconChats from './resources/icons/iconChats.vue';
import iconCalendar from './resources/icons/iconCalendar.vue';
import iconVision from './resources/icons/iconVision.vue';
import iconStudio from './resources/icons/iconStudio.vue';
import iconVirtualTryOn from './resources/icons/iconVirtualTryOn.vue';
import iconCarrinho from './resources/icons/iconCarrinho.vue';


// ----------------------------------------------------
// Functions
// ----------------------------------------------------
import RouteService from "_root/logic/services/RouteService.js";
import SessionService from '_root/logic/services/SessionService.js';
import SocketService from '_root/logic/services/SocketService.js';


import ApiService from "_root/logic/services/ApiService.js";
import FormUtils from "_root/logic/utils/FormUtils.js";
import Utils from '_root/logic/functions/Utils.js';

import AuthService from "_root/logic/services/AuthService.js";
import Attributs_funcion from '_root/logic/functions/Attributs.js';
import Time from '_root/logic/functions/Time.js';


import { setupCalendar, Calendar, DatePicker } from 'v-calendar';
import VueVirtualScroller from 'vue-virtual-scroller'


// ----------------------------------------------------
// Templates
// ----------------------------------------------------
import TemplatePage from "_app/resources/templates/TemplatePage.vue";
import LayoutMenu from "_app/resources/templates/_menuLateral.vue";
import Cell from "_app/resources/templates/_partials/_cell.vue";
import noData from '_app/resources/templates/_partials/_noData.vue';
import TemplatePageDefault from '_app/resources/templates/_pageDefault.vue'
import TemplateComponent from "_app/resources/templates/_partials/_component.vue";

import noPermission from '_app/resources/templates/_partials/_noPermission.vue';
import PlanDemoOverlay from '_app/resources/templates/_partials/_planDemoOverlay.vue';




// ----------------------------------------------------
// Components
// ----------------------------------------------------
import FormConstructor from '_root/app/resources/components/formConstructor/FormConstructor.vue';


import PopMenu from '_app/resources/components/elements/PopMenu.vue';

import Avatar from '_app/resources/components/elements/Avatar.vue';
import ImageUploader from '_app/resources/components/elements/ImageUploader.vue';
import PageSubHeaderAvatar from "_app/resources/components/cruds/PageSubHeaderAvatar.vue";
import PageHeader from '_app/resources/components/cruds/PageHeader.vue';
import Breadcrumb from '_app/resources/components/navigation/Breadcrumb.vue';
import CardDashboardVue from "_app/resources/components/cards/CardDashboard.vue";
import Tools from '_app/resources/components/cruds/bars/Tools.vue';
import ListOptionsUsers from '_app/resources/components/cruds/lists/ListOptionsUsers.vue';
import ListOptions from '_app/resources/components/cruds/lists/ListOptions.vue';
import ListItems from '_app/resources/components/cruds/lists/ListItems.vue';
import ListForms from '_root/app/resources/components/cruds/lists/ListForms.vue';

import ListChats from '_root/app/resources/components/cruds/lists/ListChats.vue';
import ListSchedules from '_root/app/resources/components/cruds/lists/ListSchedules.vue';
import ListContacts from '_app/resources/components/cruds/lists/ListContacts.vue';

import DataRowsTable from '_app/resources/components/cruds/form/elements/DataRowsTable.vue';
import ContactDropdown from '_app/resources/components/cruds/form/elements/ContactDropdown.vue';

import Tabs from "_app/resources/components/cruds/form/elements/Tabs.vue";
import SimpleTabs from "_app/resources/components/cruds/form/elements/SimpleTabs.vue";
import TabsIcons from "_app/resources/components/cruds/form/elements/TabsIcons.vue";
import TabsVertical from "_app/resources/components/cruds/form/elements/TabsVertical.vue";
import Slider from '_app/resources/components/sliders/Slider.vue';
import SliderLarge from '_app/resources/components/sliders/SliderLarge.vue';
import Dialog from '_app/resources/components/sliders/Dialog.vue';
import Modal from '_app/resources/components/sliders/Modal.vue';



import AvatarEditor from '_root/app/resources/components/cruds/form/fields/AvatarEditor.vue';
import MemberAdder from '_root/app/resources/components/cruds/form/fields/MemberAdder.vue';

import ArrayOptions from '_app/resources/components/cruds/form/fields/ArrayOptions.vue';
import Attributs from '_app/resources/components/cruds/form/fields/Attributs.vue';

import ArrayList from '_app/resources/components/cruds/form/fields/ArrayList.vue';
import Text from '_app/resources/components/cruds/form/fields/Text.vue';
import TextSub from '_app/resources/components/cruds/form/fields/TextSub.vue';

import Textarea from '_app/resources/components/cruds/form/fields/Textarea.vue';

import InputText from '_app/resources/components/cruds/form/fields/InputText.vue';
import InputNumber from '_app/resources/components/cruds/form/fields/InputNumber.vue';
import InputColorPicker from '_app/resources/components/cruds/form/fields/InputColorPicker.vue';

import Switch from '_app/resources/components/cruds/form/fields/Switch.vue';
import Checkbox from '_app/resources/components/cruds/form/fields/Checkbox.vue';
import InputEmail from '_app/resources/components/cruds/form/fields/InputEmail.vue';
import DropDown from '_app/resources/components/cruds/form/fields/DropDown.vue';
import DropDownPriority from '_app/resources/components/cruds/form/fields/DropDownPriority.vue';
import DropDownPrivacy from '_app/resources/components/cruds/form/fields/DropDownPrivacy.vue';
import DropDownSearch from '_app/resources/components/cruds/form/fields/DropDownSearch.vue';
import MultDropDown from '_app/resources/components/cruds/form/fields/MultDropDown.vue';

import SelectConditional from '_app/resources/components/cruds/form/fields/SelectConditional.vue';
import SelectImage from '_app/resources/components/cruds/form/fields/SelectImage.vue';

import DropDownTime from '_app/resources/components/cruds/form/fields/DropDownTime.vue';
import DropDownSearchWorkspaces from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchWorkspaces.vue';
import DropDownSearchModules from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchModules.vue';
import DropDownSearchIntegration from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchIntegration.vue';
import DropDownSearchIntegrationWhastappTemplateMessage from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchIntegrationWhastappTemplateMessage.vue';
import DropDownSearchAgentUsers from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchAgentUsers.vue';


import DropDownSearchDepartaments from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchDepartaments.vue';
import DropDownSearchDepartamentsForm from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchDepartamentsForm.vue';
import DropDownFacebookPages from '_app/resources/components/cruds/form/inteligentsFields/DropDownFacebookPages.vue';

import DropDownSearchBots from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchBots.vue';
import DropDownSearchMembers from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchMembers.vue';
import DropDownSearchAssistents from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchAssistents.vue';
import DropDownSearchFunnels from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchFunnels.vue';
import DropDownSearchFunnelsEtapas from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchFunnelsEtapas.vue';
import DropDownSearchFormFields from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchFormFields.vue';


import DropDownSearchEmails from '_app/resources/components/cruds/form/inteligentsFields/DropDownSearchEmails.vue';

import SelectorDepartaments from '_app/resources/components/cruds/form/inteligentsFields/SelectorDepartaments.vue';

import TreeDepartaments from '_app/resources/components/cruds/form/fields/TreeDepartaments.vue';

import Upload from '_app/resources/components/cruds/form/fields/Upload.vue';

import Radio from '_app/resources/components/cruds/form/fields/Radio.vue';
import RadioList from '_app/resources/components/cruds/form/fields/RadioList.vue';
import Editor from '_app/resources/components/cruds/elements/Editor.vue';

import InputColors from '_app/resources/components/cruds/form/fields/InputColors.vue';
import SubmitButton from '_app/resources/components/cruds/form/elements/SubmitButton.vue';
import Carousel from '_app/resources/components/cruds/elements/Carousel.vue';


import ListUsersCard from '_app/resources/components/cruds/lists/ListUsersCard.vue';
import ListUsersCardBig from '_app/resources/components/cruds/lists/ListUsersCardBig.vue';
import ListControl from '_app/resources/components/cruds/lists/_partials/ListControl.vue';
import ListOwners from '_app/resources/components/cruds/lists/ListOwners.vue';
import ListBigCard from '_app/resources/components/cruds/lists/ListBigCard.vue';
import SearchField from '_app/resources/components/cruds/form/fields/SearchField.vue';

import TagSelector from '_app/resources/components/tags/TagSelector.vue';


// ----------------------------------------------------
// Axios configuration
// ----------------------------------------------------
axios.defaults.baseURL = import.meta.env.VITE_SERVER;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + SessionService.getToken();
axios.defaults.timeout = 300000; // 5 minutos (300 segundos)
// ----------------------------------------------------


import { createPinia } from 'pinia'
const pinia = createPinia()

import io from 'socket.io-client';
const socket = io(import.meta.env.VITE_SOCKET + '/', {
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  randomizationFactor: 0.5,
  timeout: 20000,
  autoConnect: false,
  transports: ['websocket'],
  auth: { token: SessionService.getToken() },
});

// ----------------------------------------------------

const app = createApp(App)
app.use(router)
app.use(VueAxios, axios)
app.use(i18n)
app.use(VueVirtualScroller)
app.use(setupCalendar, {})
app.use(pinia)
// Global properties to stores
pinia.use(() => ({
      socket,
      ApiService: ApiService,
      router: router,
}));


// Icons
app.component('robotIcon', robotIcon)
app.component('iconGalery', iconGalery)
app.component('iconAudioWave', iconAudioWave)
app.component('iconResponse', iconResponse)
app.component('icon3Dots', icon3Dots)
app.component('iconConnection', iconConnection)
app.component('iconContacts', iconContacts)
app.component('iconEdit', iconEdit)
app.component('iconDelete', iconDelete)
app.component('iconWebhook', iconWebhook)
app.component('iconAlert', iconAlert)
app.component('iconFunnel', iconFunnel)
app.component('iconChats', iconChats)
app.component('iconCalendar', iconCalendar)
app.component('iconVision', iconVision)
app.component('iconStudio', iconStudio)
app.component('iconVirtualTryOn', iconVirtualTryOn)
app.component('iconCarrinho', iconCarrinho)



// Components
app.component('VCalendar', Calendar)
app.component('VDatePicker', DatePicker)

app.component('PopMenu', PopMenu)

app.component('TemplatePage', TemplatePage)
app.component('Avatar', Avatar)
app.component('ImageUploader', ImageUploader)
app.component('Cell', Cell)
app.component('TemplatePageDefault', TemplatePageDefault)
app.component('TemplateComponent', TemplateComponent)
app.component('FormConstructor', FormConstructor)

app.component('Slider', Slider)
app.component('SliderLarge', SliderLarge)
app.component('Dialog', Dialog)
app.component('Modal', Modal)

app.component('LayoutMenu', LayoutMenu)
app.component('PageSubHeaderAvatar', PageSubHeaderAvatar)
app.component('PageHeader', PageHeader)
app.component('Breadcrumb', Breadcrumb)
app.component('CardDashboardVue', CardDashboardVue)
app.component('Tools', Tools)
app.component('ListOptionsUsers', ListOptionsUsers)
app.component('ListOptions', ListOptions)
app.component('ListItems', ListItems)
app.component('ListForms', ListForms)

app.component('ListChats', ListChats)
app.component('ListSchedules', ListSchedules)
app.component('ListContacts', ListContacts)


app.component('noData', noData)
app.component('noPermission', noPermission)
app.component('PlanDemoOverlay', PlanDemoOverlay)

app.component('DataRowsTable', DataRowsTable)
app.component('Tabs', Tabs)
app.component('SimpleTabs', SimpleTabs)
app.component('TabsIcons', TabsIcons)
app.component('TabsVertical', TabsVertical)
app.component('Text', Text)
app.component('TextSub', TextSub)
app.component('Textarea', Textarea)
app.component('Attributs', Attributs)

app.component('ContactDropdown', ContactDropdown)


app.component('AvatarEditor', AvatarEditor)
app.component('MemberAdder', MemberAdder)


app.component('ArrayOptions', ArrayOptions)
app.component('ArrayList', ArrayList)
app.component('InputText', InputText)
app.component('InputNumber', InputNumber)
app.component('InputEmail', InputEmail)
app.component('InputColors', InputColors)
app.component('InputColorPicker', InputColorPicker)

app.component('Switch', Switch)


app.component('Checkbox', Checkbox)
app.component('Radio', Radio)
app.component('RadioList', RadioList)

app.component('DropDown', DropDown)
app.component('DropDownPriority', DropDownPriority)
app.component('DropDownPrivacy', DropDownPrivacy)
app.component('DropDownSearch', DropDownSearch)
app.component('DropDownSearchIntegration', DropDownSearchIntegration)
app.component('DropDownSearchIntegrationWhastappTemplateMessage', DropDownSearchIntegrationWhastappTemplateMessage)

app.component('DropDownSearchAgentUsers', DropDownSearchAgentUsers)

app.component('MultDropDown', MultDropDown)
app.component('SelectConditional', SelectConditional)
app.component('SelectImage', SelectImage)

app.component('DropDownTime', DropDownTime)
app.component('DropDownSearchWorkspaces', DropDownSearchWorkspaces)
app.component('DropDownSearchModules', DropDownSearchModules)
app.component('DropDownSearchDepartaments', DropDownSearchDepartaments)
app.component('DropDownSearchDepartamentsForm', DropDownSearchDepartamentsForm)
app.component('DropDownFacebookPages', DropDownFacebookPages)

app.component('SelectorDepartaments', SelectorDepartaments)

app.component('DropDownSearchBots', DropDownSearchBots)
app.component('DropDownSearchMembers', DropDownSearchMembers)
app.component('DropDownSearchAssistents', DropDownSearchAssistents)
app.component('DropDownSearchFunnels', DropDownSearchFunnels)
app.component('DropDownSearchFunnelsEtapas', DropDownSearchFunnelsEtapas)
app.component('DropDownSearchFormFields', DropDownSearchFormFields)

app.component('DropDownSearchEmails', DropDownSearchEmails)

app.component('TreeDepartaments', TreeDepartaments)
app.component('Editor', Editor)
app.component('Upload', Upload)

app.component('SubmitButton', SubmitButton)
app.component('ListUsersCard', ListUsersCard)
app.component('ListUsersCardBig', ListUsersCardBig)
app.component('ListBigCard', ListBigCard)
app.component('SearchField', SearchField)
app.component('ListControl', ListControl)
app.component('ListOwners', ListOwners)

app.component('Carousel', Carousel)

app.component('TagSelector', TagSelector)


// Global
app.config.globalProperties.$cacheManager = CacheManager; // Global Cache
app.config.globalProperties.$socket = socket; // Global Socket
app.config.globalProperties.$RouteService = RouteService;
app.config.globalProperties.$SessionService = SessionService;
app.config.globalProperties.$SocketService = SocketService;


app.config.globalProperties.$ApiService = ApiService;
app.config.globalProperties.$FormUtils = FormUtils;
app.config.globalProperties.$Utils = Utils;
app.config.globalProperties.$AuthService = AuthService;
app.config.globalProperties.$Attributs = Attributs_funcion;
app.config.globalProperties.$Time = Time;
app.config.globalProperties.$token = SessionService.getToken();

app.mount('#app')